// Questo codice è di ChatGPT
import React, { useEffect, useState } from 'react';

const InfoPage = () => {
    const [version, setVersion] = useState('1.0.0'); // Valore iniziale per la versione
    const [apiEndpoints, setApiEndpoints] = useState([
        { name: 'Login', url: 'https://api.sportifyapp.co/auth/login' },
        { name: 'Register', url: 'https://api.sportifyapp.co/auth/register' },
        { name: 'Get User Data', url: 'https://api.sportifyapp.co/user/data' },
    ]);

    useEffect(() => {
        // Esempio di aggiornamento della versione da un'API esterna
        // fetch('/version').then(res => res.json()).then(data => setVersion(data.version));
    }, []);

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1>Benvenuto nella Dashboard!</h1>
            <section style={{ marginBottom: '20px' }}>
                <h2>Informazioni App</h2>
                <p><strong>Versione:</strong> {version}</p>
                <p><strong>Ambiente:</strong> Produzione</p>
            </section>
            <section style={{ marginBottom: '20px' }}>
                <h2>Endpoint API</h2>
                <ul>
                    {apiEndpoints.map((endpoint, index) => (
                        <li key={index}>
                            <strong>{endpoint.name}:</strong> <a href={endpoint.url} target="_blank" rel="noopener noreferrer">{endpoint.url}</a>
                        </li>
                    ))}
                </ul>
            </section>
            <section>
                <h2>Note per gli sviluppatori</h2>
                <p>Assicurarsi di includere un token di autenticazione valido nelle richieste API. Controllare la documentazione per ulteriori dettagli.</p>
            </section>
        </div>
    );
};

export default InfoPage;
